<div class="professional-card"
     [ngClass]="{
       'premium': isPurchaseCard,
       'focused': isFocused,
       'compact': hideDescription
     }"
     [attr.aria-label]="title + (description ? ': ' + description : '')"
     tabindex="0"
     role="link"
     (mouseenter)="onCardHover(true)"
     (mouseleave)="onCardHover(false)"
     (focus)="onCardFocus(true)"
     (blur)="onCardFocus(false)"
     (keydown.enter)="activateCard($event)"
     (keydown.space)="activateCard($event)">

  <!-- Clean backdrop -->
  <div class="card-backdrop"></div>

  <!-- Premium indicator -->
  <div class="premium-indicator" *ngIf="isPurchaseCard">
    <mat-icon aria-hidden="true">lock_outline</mat-icon>
    <span>Premium</span>
  </div>

  <!-- Main content -->
  <div class="card-content">

    <!-- Header with icon -->
    <div class="card-header">
      <div class="icon-container" [style.background]="getIconGradient()">
        <div class="icon-wrapper">
          <ng-content select="[icon]"></ng-content>
        </div>
      </div>
    </div>

    <!-- Content section -->
    <div class="card-body">
      <!-- Title -->
      <h3 class="card-title">{{ title }}</h3>

      <!-- Description (CSS line-clamp handles truncation) -->
      <div class="description-section" *ngIf="!hideDescription">
        <p #descriptionContainer
           class="card-description"
           [class.expanded]="showFullDescription">
          {{ description }}
        </p>

        <button *ngIf="isDescriptionTruncated"
                type="button"
                class="read-more-btn"
                (click)="toggleDescription($event)"
                [class.expanded]="showFullDescription"
                [attr.aria-expanded]="showFullDescription"
                [attr.aria-label]="showFullDescription ? 'Show less' : 'Read more'">
          <span>{{ showFullDescription ? 'Show less' : 'Read more' }}</span>
          <mat-icon aria-hidden="true">{{ showFullDescription ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>
      </div>
    </div>

    <!-- Footer: honest navigation / purchase affordance -->
    <div class="card-footer">
      <div class="selection-status">
        <div class="status-indicator" [class.active]="isHovered || isFocused">
          <mat-icon aria-hidden="true">{{ isPurchaseCard ? 'lock_outline' : 'arrow_forward' }}</mat-icon>
          <span>{{ isPurchaseCard ? 'Premium Required' : 'Open' }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Hover highlight border -->
  <div class="selection-border" [class.visible]="isHovered"></div>
</div>
